import { Link } from 'react-router-dom';
import { comics, hotComicIds } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function HotComics() {
  const hotComics = hotComicIds.map((id) => comics.find((c) => c.id === id)!);

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-end justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-2">韩漫爱好者最爱的精选作品</p>
        </div>
        <Link
          to="/category/hot"
          className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
        >
          查看全部 <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {hotComics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}